import React from "react";

export const RankBadge = ({ rank }) => {
  const id = rank.toLowerCase().replace(/\s+/g, "-");
  return (
    <img src={`/rank-badges/${id}.svg`} alt={`${rank} rank badge`} width="32" height="32" className="h-8 w-8 object-contain shrink-0" data-testid={`wager-rank-icon-${id}`} />
  );
};